// extracted by mini-css-extract-plugin
export var numpadContainer = "_kk-1";
export var phoneButton = "_kk-0";